import LocationInfo from '../components/quotes/LocationInfo.vue';
import TelnoLookup from '../components/quotes/TelnoLookup.vue';


export default [

	{
		path: '/quotes/location-info',
		name: 'LocationInfo',
		component: LocationInfo,
		meta: {
			requiresAuth: true,
			permissions: {
				Quoting: ["Address Info"]
			}
		}
	},

	{
		path: '/quotes/telno-lookup',
		name: 'TelnoLookup',
		component: TelnoLookup,
		meta: {
			requiresAuth: true,
			permissions: {
				Quoting: ["Telephone Lookup"]
			}
		}
	},
]



// WEBPACK FOOTER //
// ./src/router/QuotesRoutes.js